var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstgramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.024,0H148.976C69.063,0,4.281,64.782,4.281,144.695v222.61C4.281,447.218,69.063,512,148.976,512h214.047 c79.914,0,144.695-64.782,144.695-144.695v-222.61C507.719,64.782,442.937,0,363.024,0z M55.652,144.695 c0-51.461,41.863-93.324,93.324-93.324h214.047c51.461,0,93.324,41.863,93.324,93.324v222.61c0,51.461-41.863,93.324-93.324,93.324 H148.976c-51.461,0-93.324-41.863-93.324-93.324V144.695z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,387.851c72.703,0,131.852-59.148,131.852-131.851S328.703,124.145,256,124.145 c-72.702,0-131.851,59.152-131.851,131.855S183.297,387.851,256,387.851z M256,165.242c50.043,0,90.754,40.714,90.754,90.758 S306.043,346.758,256,346.758c-50.042,0-90.754-40.714-90.754-90.758S205.957,165.242,256,165.242z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 391.707,
    cy: 120.296,
    rx: 29.539,
    ry: 29.541
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstgramIcon);
export default __webpack_public_path__ + "static/media/instgram_icon.fb7a683aacb6c90090842cd89f39f36c.svg";
export { ForwardRef as ReactComponent };